import { useState } from "react";
import Loader from "./Loader";

interface IOwnProps {
 src?: string;
 title?: string;
}

export const Iframe: React.FC<IOwnProps> = (props: IOwnProps) => {
 const [isloading, setIsloading] = useState(true);
 return (<>
  {isloading && <Loader inline />}
  <iframe src={props?.src} title={props?.title} width="100%" height="100%" style={{ margin: 0, padding: 0 }} onLoad={() => setIsloading(false)} />
 </>
 );
};